import { ModuleWithProviders } from '@angular/core';
import { Routes, RouterModule, PreloadAllModules } from '@angular/router';
import {Constant} from "./common/constant";
import { PublicViewImageComponent } from './common/components/public-view-image/public-view-image';
import { CommonLayoutComponent } from './layouts/common-layout/common-layout.component';
import { CommonLayout_ROUTES } from './layouts/common-layout.routes';

const routes: Routes = [
  {
    path: '',
    redirectTo: '/auth/login',
    pathMatch: 'full',
  },
  {
    path: 'null',
    redirectTo: '/auth/login',
    pathMatch: 'full',
  },
  {
    path: 'account',
    component: CommonLayoutComponent,
    children: CommonLayout_ROUTES
  },
  { path: Constant.code_issuer, loadChildren: () => import('./main/issuer/issuer.module').then(m => m.IssuerModule)},
  // { path: Constant.path_account, loadChildren: () => import('./main/main.module').then(m => m.MainModule)},
  { path: Constant.path_auth, loadChildren: () => import('./authorization/auth.module').then(m => m.AuthModule) },
  { path: 'view-image', component: PublicViewImageComponent },
];

export const AppRouting: any = RouterModule.forRoot(routes, {
  preloadingStrategy: PreloadAllModules,  // <- comment this line for activate lazy load
  // useHash: true
});

